import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createBooking = (form) =>
  axios.post(`${API}/bookings`, {
    name: form.name,
    email: form.email,
    phone: form.phone,
    session_type: form.sessionType,
    package_type: form.packageType,
    preferred_date: form.preferredDate,
    message: form.message,
  }).then(r => r.data);

const adminHeaders = (key) => ({ headers: { 'X-Admin-Key': key } });

export const adminLogin = (key) => axios.post(`${API}/admin/login`, null, adminHeaders(key)).then(r => r.data);
export const listPaymentLinks = (key) => axios.get(`${API}/admin/payment-links`, adminHeaders(key)).then(r => r.data);
export const createPaymentLink = (key, data) => axios.post(`${API}/admin/payment-links`, data, adminHeaders(key)).then(r => r.data);

export const fetchPaymentLink = (id) => axios.get(`${API}/pay/${id}`).then(r => r.data);
export const startCheckout = (id) => axios.post(`${API}/pay/${id}/checkout`, { origin_url: window.location.origin }).then(r => r.data);
export const fetchPaymentStatus = (sessionId) => axios.get(`${API}/payments/status/${sessionId}`).then(r => r.data);
